/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface OTPViaSMSMethodOptions
 */
export interface OTPViaSMSMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof OTPViaSMSMethodOptions
     */
    method: FactorMethod;
}

/**
 * Check if a given object implements the OTPViaSMSMethodOptions interface.
 */
export function instanceOfOTPViaSMSMethodOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function OTPViaSMSMethodOptionsFromJSON(json: any): OTPViaSMSMethodOptions {
    return OTPViaSMSMethodOptionsFromJSONTyped(json, false);
}

export function OTPViaSMSMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPViaSMSMethodOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function OTPViaSMSMethodOptionsToJSON(value?: OTPViaSMSMethodOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': FactorMethodToJSON(value.method),
    };
}

